import { Typescratcher as Ts } from "@tscratch3/typescratcher";
const htmlStringVirtualPad = `
<div id="virtualPad">
    <div class="d-KEY">
        <button id="btnSpace">SPACE</button>
    </div>
    <div class="d-KEY">
        <button id="btnA">A</button>
    </div>
 </div>
`;
const cssStringVirtualPad = `
    #virtualPad {
        display: none; /* デフォルト（PC）では非表示 */
    }
    #virtualPad {
        display: block;
        position: relative;
        top: 20px;
        bottom: 0px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between; /* 左右に振り分ける */
        padding: 0 40px;
        pointer-events: none; /* コンテナ自体はクリックをすり抜ける */
    }
    .d-pad button {
        pointer-events: auto; /* ボタン自体はタッチに反応する */
        width: 60px;
        height: 60px;
        font-size: 24px;
        background: rgba(255, 255, 255, 0.6); /* 半透明 */
        border: 2px solid #333;
        border-radius: 50%; /* 丸いボタン */
        user-select: none; /* テキスト選択を防ぐ */
    }
    
    .d-KEY {
        gap:40px;
        display: flex;
        align-items: center; 
        justify-content: center;
        height: 100%; 
    }

    /* ボタンを少し大きく押しやすく */
    .d-KEY button {
        pointer-events: auto; /* ボタン自体はタッチに反応する */
        margin-left: 2rem;
        padding-left: 1rem;
        padding-right: 1rem;
        width: fit-content;
        height: 80px;
        font-weight: bold;
        font-size: 1.5rem;
        background-color: white;
        border-radius: 20%; /* 角を丸くする */
        user-select: none; /* テキスト選択を防ぐ */
    }
`;
export const virtualPad = () => {
    Ts.VirtualPad.addVirtualPad(htmlStringVirtualPad, cssStringVirtualPad);
    // 各ボタンをキーボードのキーと紐付け
    Ts.VirtualPad.setupTouchButton('btnUp', Ts.Keyboard.UP);
    Ts.VirtualPad.setupTouchButton('btnDown', Ts.Keyboard.DOWN);
    Ts.VirtualPad.setupTouchButton('btnLeft', Ts.Keyboard.LEFT);
    Ts.VirtualPad.setupTouchButton('btnRight', Ts.Keyboard.RIGHT);
    Ts.VirtualPad.setupTouchButton('btnSpace', Ts.Keyboard.SPACE);
    Ts.VirtualPad.setupTouchButton('btnA', 'A');
};
//# sourceMappingURL=virtualPad.js.map